// ------------------------------ IMPORTS
// *    Style imports
import './styles.css';

// *    Library imports
import React, {Component} from "react";
import PropTypes from 'prop-types';
// import PubSub from 'pubsub-js';

// *    Component imports
import Modal from "../Modal/Modal";
import Content from "../../content/Content";
import ModalHeader from "../ModalHeader/ModalHeader";
import GetMoreProfilesView from "./Components/GetMoreProfilesView/GetMoreProfilesView";
import GetDataBaseView from "./Components/GetDataBaseView/GetDataBaseView";
import GetBoostJob from "./Components/GetBoostJob/GetBoostJob";
import Constants from "../../constants/Constants";
// import ServerErrorHandlerView from "../ErrorView/ServerError";
import {xhrBoostJob, xhrGetCtcInfo, xhrGetMoreProfileInfo} from "./Services/Services";
import LoadingViewGetMoreProfile from "./Components/LoadingView/LoadingViewGetMoreProfile/LoadingViewGetMoreProfile";
import GetBoostJobLoadingView from "./Components/GetBoostJob/GetBoostJobLoadingView/GetBoostJobLoadingView";

// ----------------------------- END IMPORTS

class GetMoreProfilesModal extends Component {
    
    constructor(props) {

        super(props);

        this.state = {

            jobId: null,
            isOpen : true,
            isModalOpen : false,
            isBoostActive: null,
            isBoostDisabled: null,
            profileView: 1,
            isCtcModalOpen: false,
            serverCallStatus: Constants.REQUEST_STATS.PENDING,
            btnLabel: Content.BUTTONS.BOOST_JOB,
            tabIdentifier: null
        };

    }

    componentWillMount() {

        const { 
            viewType,
            location
        } = this.props;

        let tabIdentifier = location && location.state && location.state && location.state.modal && location.state.modal.tabIdentifier ? location.state.modal.tabIdentifier : 1;

        this.setState({
            profileView: viewType,

            tabIdentifier: tabIdentifier

        });
    }

    componentDidMount() {

    };

    componentWillUnmount() {

    }


    // --------------------------------------------------------- helper function
    
    setServerCallStatus = (serverCallStatus) => {

        this.setState({serverCallStatus});

    };

    // --------------------------------------------------------- Server calls

    
    // --------------------------------------------------------- listeners
    
    crossClickedHandler = () => {
        this.props.crossClickedHandler();
    };

    changeProfileView = (view) => {
        this.setState({profileView: view})
    };


    // --------------------------------------------------------- views

    getMoreProfileView = () => {
        return <GetMoreProfilesView
            
            jobId={this.state.jobId}
            changeProfileView={this.changeProfileView}
            onSuccess = {(data, forceType)=>{this.onSuccess(data, Constants.GET_MORE_PROFILES.TYPE_BOOST, forceType)}}
            onClickDbHandler = {this.onClickDbHandler}
            urlToGoBackForPaymentIdentifier = {this.props.urlToGoBackForPaymentIdentifier}
            tabIdentifier = { this.state.tabIdentifier }
            history = {this.props.history}
            location = {this.props.location}
        />
    };

    getDataBaseView = () => {
        return <GetDataBaseView
            jobId = {this.state.jobId}
            {...this.props}
            type = {Constants.GET_MORE_PROFILES.TYPE_DB_ACCESS}
            onSuccess = {(data)=>{this.onSuccess(data, Constants.GET_MORE_PROFILES.TYPE_DB_ACCESS)}}
            urlToGoBackForPaymentIdentifier = {this.props.urlToGoBackForPaymentIdentifier}
            tabIdentifier = { this.state.tabIdentifier }
            history = {this.props.history}
            location = {this.props.location}
            rate = {this.props.rate}
        />
    };

    getBoostJobView = () => {

        const { 
            jobId,
            tabIdentifier
        } = this.state;

        const {
            urlToGoBackForPaymentIdentifier,
            history,
            location
        } = this.props;

        return <GetBoostJob
            jobId = { jobId }
            type = { Constants.GET_MORE_PROFILES.TYPE_BOOST }
            onSuccess = {(data)=>{this.onSuccess(data, Constants.GET_MORE_PROFILES.TYPE_BOOST)}}
            urlToGoBackForPaymentIdentifier = { urlToGoBackForPaymentIdentifier }
            tabIdentifier = { tabIdentifier }
            history = { history }
            location = { location }
            rate = {this.props.rate}
        />
    };

    getViewToBeRendered = (typeToRender) => {
        let renderView = null;
        switch(typeToRender) {
            case 1:
                renderView = this.getMoreProfileView();
                break;
            case 2: renderView = this.getDataBaseView();
                break;
            case 3: renderView = this.getBoostJobView();
                break;
        }
        return renderView;
    };




// --------------------------------------------------------- render
    render() {
        const{isOpen, serverCallStatus, profileView} = this.state;
        return (
            <Modal
                widthPx = {808}
                top = {"0px"}
                onClose = {""}
                isOpen = {isOpen}
            >
                <ModalHeader
                    headerText = {this.state.profileView === 1 ?
                        Content.HEADERTEXT.GET_MORE_PROFILES :
                        this.state.profileView === 2 ?
                            Content.HEADERTEXT.DB_ACCESS_UPGRADE :
                            this.state.profileView === 3 ?
                                Content.HEADERTEXT.BOOST_JOB :
                                null
                    }
                    onCrossClick = {this.crossClickedHandler}
                />

                {this.getViewToBeRendered(profileView)}

            </Modal>
        );
    }

}

/**
 * all prop types which can be passed to this component
 */
GetMoreProfilesModal.propTypes = {
    jobId : PropTypes.number,
    viewType : PropTypes.number
};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
GetMoreProfilesModal.defaultProps ={
    viewType : 2
};

export default GetMoreProfilesModal;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/GetMoreProfilesModal.js